(() => {
  const initialiseLegacyAccordions = (root = document) => {
    root.querySelectorAll('.Collapsible__Button').forEach((button) => {
      if (button.dataset.epicAccordionReady === 'true') return;

      const panel = button.nextElementSibling;
      if (!panel || !panel.classList.contains('Collapsible__Inner')) return;

      button.type = 'button';
      button.dataset.epicAccordionReady = 'true';
      button.setAttribute('aria-expanded', 'false');
      panel.hidden = true;

      button.addEventListener('click', (event) => {
        event.preventDefault();
        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!expanded));
        panel.hidden = expanded;
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => initialiseLegacyAccordions());
  document.addEventListener('shopify:section:load', (event) => initialiseLegacyAccordions(event.target));
})();
